// TODO: Move this into a better structure and integrated into
// AnalyticsStore.

import { AnalyticsBrowser } from '@segment/analytics-next';

// we can export this instance to share with rest of our codebase.
// `REACT_APP_SEGMENT_WRITE_KEY` is optional (commonly unset in local dev), and
// loading with an empty key requests `cdn.segment.com/v1/projects//settings` ->
// 404 "Invalid path or write key provided". Leaving the instance unloaded keeps
// `.track()` calls buffered and inert instead. Mirrors the missing-key guard in
// `PostHogIntegration.init`.
const segmentWriteKey = process.env.REACT_APP_SEGMENT_WRITE_KEY;

export const analytics = segmentWriteKey
  ? AnalyticsBrowser.load({ writeKey: segmentWriteKey })
  : new AnalyticsBrowser();
